import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Header.css';

function Header({ isMobile }) {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // 当isMobile变化时，关闭移动菜单
  useEffect(() => {
    if (!isMobile) {
      setMobileMenuOpen(false);
    }
  }, [isMobile]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  // TODO: 根据移动端需要调整的UI元素和布局
  
  // 移动端和桌面端不同的渲染内容
  const renderContent = () => {
    if (isMobile) {
      return (
        <>
          <div className="logo">
            <img src="/logo/Frame.svg" alt="Skyris Logo" className="logo-img logo-img-mobile" />
            <span className="logo-text logo-text-mobile">SKYRIS</span>
          </div>
          
          <button className="menu-button menu-button-mobile" onClick={toggleMobileMenu} aria-label="Open menu">
            <span className={`hamburger hamburger-mobile ${mobileMenuOpen ? 'open' : ''}`}></span>
          </button>
          
          {mobileMenuOpen && (
            <div className="mobile-menu-container">
              <div className="mobile-menu">
                <nav>
                  <ul>
                    <li><a href="#introduction" onClick={toggleMobileMenu}>
                      {t('nav.introduction')}
                    </a></li>
                    <li><a href="#use-case-gallery" onClick={toggleMobileMenu}>
                      {t('nav.useCaseGallery')}
                    </a></li>
                    <li><a href="https://demo.skyrisai.com" onClick={toggleMobileMenu}>
                      {t('nav.fashion')}
                    </a></li>
                    <li><a href="#technology" onClick={toggleMobileMenu}>
                      {t('nav.technology')}
                    </a></li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </>
      );
    } else {
      // 桌面端渲染内容
      return (
        <>
          <div className="logo">
            <img src="/logo/Frame.svg" alt="Skyris Logo" className="logo-img" />
            <span className="logo-text">SKYRIS</span>
          </div>
          <nav className="nav-desktop">
            <ul>
              <li><a href="#introduction">{t('nav.introduction')}</a></li>
              <li><a href="#use-case-gallery">{t('nav.useCaseGallery')}</a></li>
              <li><a href="https://demo.skyrisai.com">{t('nav.fashion')}</a></li>
              <li><a href="#technology">{t('nav.technology')}</a></li>
            </ul>
          </nav>
          <button className="menu-button" onClick={toggleMobileMenu}>
            <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}></span>
          </button>
          
          {mobileMenuOpen && (
            <div className="mobile-menu">
              <nav>
                <ul>
                  <li><a href="#introduction" onClick={toggleMobileMenu}>{t('nav.introduction')}</a></li>
                  <li><a href="#use-case-gallery" onClick={toggleMobileMenu}>{t('nav.useCaseGallery')}</a></li>
                  <li><a href="https://demo.skyrisai.com" onClick={toggleMobileMenu}>{t('nav.fashion')}</a></li>
                  <li><a href="#technology" onClick={toggleMobileMenu}>{t('nav.technology')}</a></li>
                </ul>
              </nav>
            </div>
          )}
        </>
      );
    }
  };
  
  return (
    <header className={`header ${isMobile ? 'header-mobile' : ''}`}>
      {renderContent()}
    </header>
  );
}

export default Header; 